import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { CompanyMetricsRecord } from 'src/models';
import { RootState } from 'src/store';
import { metricsSelectors } from 'src/store/reducers/companyMetrics';

export const useCompanyMetricsState = (): RootState['companyMetrics'] => {
  const metrics = useSelector<RootState, RootState['companyMetrics']>(
    (state) => state.companyMetrics,
  );

  useDebugValue(metrics);

  return metrics;
};

export const useCompanyMetrics = (): CompanyMetricsRecord[] => {
  const metrics = useSelector<RootState, RootState['companyMetrics']>(
    (state) => state.companyMetrics,
  );

  const result = metricsSelectors.selectAll(metrics);

  useDebugValue(result);

  return result;
};
